import styles from "../../styles/Product.module.css";
import { ProductModel } from '../../models/product';
import { useShopContext } from "../../context/ShopContext";
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { formatGR } from "../../utils/formatGR";
import { BsTrash } from "react-icons/bs";
import { useRef, useState } from "react";
import DeletionToast from "./DeletionToast";


interface cartItemProps {
    cartItem: ProductModel
}

const CartItem = ({cartItem}: cartItemProps) => {

    // We create a reference to the inputbox in order to select its text when it is clicked.
    // This way we prevent it from calling the delete item toast
    const textFieldRef = useRef<HTMLInputElement>(null);

    const {
        ID,
        NAME,
        CODE,
        BRAND,
        FACTORYCODE,
        PRICE,
        QUANTITY,
        MAX,
        UNIT,
        AMOUNT
    } = cartItem;

    const { addItem, removeItem, manualAddRemoveItem } = useShopContext();
    const [isFlashing, setIsFlashing] = useState(false);
    const [showToast, setShowToast] = useState(false);

    const closeToast = () => {
        setShowToast(false);
    }

    const flashTrigger = () => {
        setIsFlashing(true); // Set isFlashing to true
        // Schedule a function to set isFlashing back to false after 1 second
        setTimeout(() => {
          setIsFlashing(false); // Set isFlashing back to false
        }, 2000); // 1000 milliseconds = 1 second
      };

    return (
        <Card className={`${styles.productCard} rounded-0 p-0`}>
            {
                showToast && (
                    <DeletionToast itemCode={ID} onClose={closeToast}/>
                )
            }
            <Card.Header className={`${styles.cardHeader} d-flex justify-content-between rounded-0 p-2`}>
                <div>Κωδικός: {CODE}</div>
                <div>Μάρκα: {BRAND}</div>
                <div>SKU: {FACTORYCODE}</div>
            </Card.Header>
            <Card.Body className={`${styles.cardBody} d-flex justify-content-between align-items-center`}>
                <Col className="col">
                    <Row>
                        <Card.Title className={styles.cardTitle}>
                            {NAME}
                        </Card.Title>
                    </Row>
                </Col>
                <Col className="px-3 col col-lg-auto">
                    <Row className="justify-content-end align-items-center">
                        <Button className={`${styles.ButtonDelete} bg-transparent border-1 border-dark border-1 p-0 me-2 d-flex align-items-center justify-content-center`} onClick={() => {
                            setShowToast(true);
                        }}><BsTrash size="20px" className="text-dark" />
                        </Button>
                        <Button className={`${styles.ButtonMinus} bg-dark border-0`} onClick={() => {
                            if (AMOUNT !== 1) {
                                removeItem(ID);
                            } else {
                                setShowToast(true);
                            }
                        }}>
                        </Button>
                        <Form.Control ref={textFieldRef} type="text" name="quantity" inputMode="numeric" pattern="[0-9]*" className={styles.FormControl} value={Number(AMOUNT)} onChange={(e) => {
                            if (Number(e.target.value) <= QUANTITY) {
                                if (Number(e.target.value) === 0) {
                                    setShowToast(true);
                                } else {
                                    manualAddRemoveItem(ID, cartItem, Number(e.target.value));
                                    setTimeout(() => { textFieldRef.current?.blur(); }, 2000);
                                }
                            } else {
                                flashTrigger();
                                textFieldRef.current?.blur();
                            }
                        }}
                        onClick={() => {
                            if (textFieldRef.current) {
                                textFieldRef.current.select();  //select inputbox text to prevent it from showing the delete item toast
                            }
                        }}
                        />
                        <Button className={`${styles.ButtonPlus} bg-dark border-0`} onClick={() => {
                            if (Number(AMOUNT+1) <= Number(QUANTITY)) {
                                addItem(ID, cartItem);
                            } else {
                                flashTrigger();
                            }
                        }}>
                        </Button>
                        {UNIT}
                    </Row>
                </Col>
            </Card.Body>
            <Card.Footer className={`${styles.cardFooter} d-flex justify-content-between rounded-0 p-2`}>
            {MAX && (
                QUANTITY / MAX === 0 ? <div className={`${styles.availability} text-light bg-danger rounded ${isFlashing ? 'flash' : ''}`}>Μη διαθέσιμο</div> :
                QUANTITY / MAX <= 0.15 ? <div className={`${styles.availability} text-dark bg-warning rounded ${isFlashing ? 'flash' : ''}`}>Πολύ χαμηλό απόθεμα</div> :
                QUANTITY / MAX <= 0.3 ? <div className={`${styles.availability} text-dark bg-warning rounded ${isFlashing ? 'flash' : ''}`}>Χαμηλό απόθεμα</div> :
                <div className={`${styles.availability} text-light bg-success rounded ${isFlashing ? 'flash' : ''}`}>Σε απόθεμα</div>
            )}
                <div>Τιμή (με ΦΠΑ): {formatGR(PRICE)}€</div>
                <div>Σύνολο: {formatGR(PRICE*AMOUNT)}€</div>
            </Card.Footer>
        </Card>
    )
}

export default CartItem;